import classNames from "node_modules/classnames";
import React from "react";

interface HeadingProps {
  size?: "sm" | "md" | "lg";
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  className?: string;
  children?: React.ReactNode;
}

const Heading: React.FC<HeadingProps> = ({
  size = "lg",
  level = 1,
  className = "",
  children = null,
}) => {
  const headingClass = classNames(
    "font-semibold inline-block text-modal-blue leading-10 my-4",
    {
      "text-2xl": size === "md",
      "text-32": size === "lg",
      [className]: className,
    }
  );
  const Tag = `h${level}` as "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  return <Tag className={headingClass}>{children}</Tag>;
};

export default Heading;
